// react and mui stuff
import { useContext, useEffect, useState } from "react";
import { ToastContext } from "../../components/toast";
import { UserContext } from "../../utils/contexts";

import Box from "@mui/joy/Box";
import Button from "@mui/joy/Button";

// styles
import "../../styles/daedalus.css"
import "../../styles/emberanimations.css"

// data and stuff
import pLore from "../../data/placeholderlore";
import { Lore } from "../../types/daedalus";
import { setData } from "../../utils/setdata";
import { daedalusAPI, imgSrc } from "../../utils/backend";

function BTN({ loading, name }: { loading: boolean, name: string }) {
  const [value, setValue] = useState(0)
  function changeNum() {
    if (value > 8) setValue(0)
    else setValue(value + 1)
  }
  
  return (
    <button className="coolText keyButton col-4" disabled={loading} type="button" value={value} onClick={changeNum} id={name}>
      {value}
    </button>
  )
}

function PadRow({ loading, i }: { loading: boolean, i: number }) {
  const arr = new Array(3).fill(0).map((v, i) => i)

  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      {arr.map(x => <BTN loading={loading} key={`${i}${x}`} name={`${i}${x}`}/>)}
    </div>
  )
}

function DaedalusLetter({letter}: { letter: string }) {
  const [animating, setAnimating] = useState(true);
  return <Box
    sx={{ padding: "0px 6px",  "--in-time": `${(Math.random() * 3) + 2}s`, cursor: "pointer" }}
    className={animating ? "titleAnim" : "titleUnan"}
    onClick={() => { if (!animating) setAnimating(true) }}
    onAnimationEnd={() => setAnimating(false)}
  >
    {letter}
  </Box>
}

export default function DPad() {
  const [reset, setReset] = useState("0");
  const [lore, setLore] = useState<Lore[]>(pLore())
  const { setToast } = useContext(ToastContext)
  const { user, setUser } = useContext(UserContext);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // get the info
    if (!user) return;
    daedalusAPI.getLore().then(info => {
      setLoading(false);

      if (!setData(info, setToast, user, setUser)) return;      
      setLore(info)
    })
  }, [setToast, setUser, user])

  if (!user) return <></>

  const header = "DAEDALUS".split("").map((l, i) => <DaedalusLetter letter={l} key={i}/>)
  const buttons = new Array(4).fill(0).map((v, i) => i);

  return (
    <div>
      {/** Daedalus logo */}
      <div style={{ display: "flex", justifyContent: "center" }}>
        <picture>
          <source height="225px" width="180px" srcSet={imgSrc("daedalus/daedalus.webp")} type="image/webp"/>
          <img src={imgSrc("daedalus/daedalus.png")} alt="Daedalus" height="225px" width="180px" style={{ marginTop: "25px"}}/>
        </picture>
      </div>

      {/** Lore */}
      <div style={{ display: "flex", justifyContent: "center" }}>
        {
          lore.map(l => (
            <a
              href={l.lore ? l.lore : undefined}
              target="_blank" rel="noreferrer"
              key={l.house}
              style={{ margin: "10px" }}
              aria-label={l.house + " Lore Video"}
            >
              <img src={imgSrc(`badges/${l.icon}`)} alt="" height="40px" width="40px" style={{ filter: l.lore ? undefined : "grayscale(100%)" }}/>
            </a>
          ))
        }
      </div>

      {/** Daedalus text */}
      <h1 className="coolText daedalusText" style={{ display: "flex", justifyContent: "center", cursor: "default" }}>
        {header}
      </h1>

      <form onSubmit={(e) => {
        e.preventDefault()
        setLoading(true)

        const btnVals: number[] = [];
        for (let y = 0; y < 4; y++) {
          for (let x = 0; x < 3; x++) {
            const cell = document.getElementById(`${y}${x}`)?.getAttribute("value") ?? "0"
            if (!cell) continue;
            btnVals.push(parseInt(cell))
          }
        }

        daedalusAPI.submitKey(btnVals.join("")).then((info) => {
          setLoading(false);
          if (!setData(info, setToast, user, setUser)) return;     
          
          setLore(info.lore);
          
          if (typeof info.result === "string") {
            return setToast({ text: info.result, color: "warning" })
          }

          if (info.result === true) setToast({ text: "Your code worked! Check Discord to see what you unlocked.", color: "success" })
          else setToast({ text: "That one didn't work, Try again!", color: "warning" })
        })
      }}>
        <div className="keypad" key={reset}>
          <Button
            disabled={loading}
            fullWidth
            color="warning"
            onClick={() => setReset(reset === "0" ? "1" : "0")}
            sx={{ marginBottom: "20px" }}
          >
            RESET
          </Button>
          {buttons.map(i => <PadRow key={i} loading={loading} i={i}/>)}
          <br/>
          <Button
            disabled={loading}
            fullWidth
            color="neutral"
            size="lg"
            type="submit"
            sx={{ marginBottom: "20px" }}
          >
            SUBMIT
          </Button>
        </div>
      </form>
    </div>
  )
}